import { GenericValue } from 'hisng';
import { ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';

export class PublicationCreatorOrgunit {
    id: number;
    creatorId: number;
    lockVersion: number;
    sortorder: number;
    organization: GenericValue; // internal organization
    researchPartner?: ResearchPartnerSimple; // external organization

    constructor( id?: number, creatorId?: number,
        organization?: GenericValue, researchPartner?: ResearchPartnerSimple, sortorder?: number ) {
        this.id = id;
        this.creatorId = creatorId;
        this.organization = organization;
        this.researchPartner = researchPartner;
        this.sortorder = sortorder;
    }
}
